export default __webpack_public_path__ + "static/media/done-icon.7a2471bd.svg";